import { useLocation, useNavigate } from 'react-router-dom';
import { SUPPORTED_LANGUAGES, DEFAULT_LANG } from '../constants/languages';

export const useLocaleNavigator = () => {
    const location = useLocation();
    const navigate = useNavigate();

    /**
     * 現在のパスを維持したまま言語を切り替える
     * @param {string} newLangCode - 切り替えたい言語コード (ex: 'en', 'ja')
     */
    const changeLanguage = (newLangCode) => {
        const { pathname } = location;
        let newPath = pathname;

        // URL末尾の言語コード判定用 (例: /about/en の 'en')
        const pathSegments = pathname.split('/').filter(Boolean);
        const lastSegment = pathSegments[pathSegments.length - 1];
        const isLangSuffix = SUPPORTED_LANGUAGES.some(l => l.code === lastSegment);

        // 1. 現在が日本語ルート(/)の場合
        if (pathname === '/') {
            newPath = newLangCode === DEFAULT_LANG ? '/' : `/${newLangCode}`;
        }
        // 2. 既に言語コードがついている場合 (/about/en -> /about/zh)
        else if (isLangSuffix) {
            if (newLangCode === DEFAULT_LANG) {
                // 日本語にする場合はサフィックスを削除 (/about/en -> /about)
                // ただし、ルート直下の言語パス(/en)の場合は / にする
                if (pathSegments.length === 1) {
                    newPath = '/';
                } else {
                    newPath = pathname.replace(`/${lastSegment}`, '');
                }
            } else {
                // 他言語への置換
                newPath = pathname.replace(`/${lastSegment}`, `/${newLangCode}`);
            }
        }
        // 3. 言語コードがついていない場合 (/about -> /about/en)
        else {
            if (newLangCode !== DEFAULT_LANG) {
                // 末尾にスラッシュがある場合の対策をして結合
                newPath = `${pathname.replace(/\/$/, '')}/${newLangCode}`;
            }
            // 日本語(/about -> /about)の場合は何もしない
        }

        navigate(newPath);
        window.scrollTo(0, 0); // ページ遷移時にトップへ
    };

    /**
     * 現在の言語コードを取得
     */
    const getCurrentLang = () => {
        const pathSegments = location.pathname.split('/').filter(Boolean);
        const lastSegment = pathSegments[pathSegments.length - 1];
        const found = SUPPORTED_LANGUAGES.find(l => l.code === lastSegment);
        return found ? found.code : DEFAULT_LANG;
    };

    return { changeLanguage, getCurrentLang };
};